import { render } from "./language-select.vue?vue&type=template&id=b725e7ec"
import script from "./language-select.vue?vue&type=script&lang=js"
export * from "./language-select.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__